import { ColDef } from 'ag-grid-community';
import { isEmpty } from 'lodash';

import { KebabMenuWrapper } from '../components/KebabMenu/KebabMenuWrapper';
import { SidebarToggle } from '../components/SidebarToggle/SidebarToggle';
import { AgGridKebabMenuOptions } from '../types';

export const appendSidebarToggler = ({
  colDefs,
  kebabMenuOptions = [],
  kebabMenuIsRowSpecific,
  kebabMenuOptionsGenerator,
  isMobileView,
  showSidebarToggle,
  autoGroupColumnDef,
  getUIOptionsForLastColumn,
  additionalMobileProps = {},
}: {
  colDefs: ColDef[];
  kebabMenuOptions?: AgGridKebabMenuOptions;
  kebabMenuIsRowSpecific?: boolean;
  kebabMenuOptionsGenerator?: (params: any) => AgGridKebabMenuOptions;
  isMobileView?: boolean;
  showSidebarToggle?: boolean;
  autoGroupColumnDef?: ColDef;
  getUIOptionsForLastColumn?: () => React.FC | null;
  additionalMobileProps?: {
    [key: string]: any;
  };
}) => {
  const columnDefs = [...colDefs];

  if (isMobileView && isEmpty(autoGroupColumnDef) && columnDefs?.length > 0) {
    columnDefs[0] = {
      ...columnDefs[0],
      pinned: 'left',
      lockPosition: 'left',
      ...additionalMobileProps,
    };
  }

  /* conditions for when we want to show kebab menu row with sidebar toggle button.

  we want to hide kebab menu toggle based on
    1. if user has opted to hide sidebarToggle and
    2. kebabMenu is non row Specific ( non changing for row specific as the computation will be heavy.) and
    3. there are no kebab menu options. 

    When above three conditions are met an empty column will be present which we want to avoid.
    Negating above condition gives following
  */
  if (
    showSidebarToggle ||
    kebabMenuIsRowSpecific ||
    Boolean(kebabMenuOptions?.length > 0 || getUIOptionsForLastColumn)
  ) {
    columnDefs.push({
      colId: 'sidebarToggler',
      headerName: '',
      maxWidth: getUIOptionsForLastColumn ? 250 : 60,
      pinned: 'right',
      headerComponent: isMobileView ? null : SidebarToggle,
      cellRenderer: KebabMenuWrapper,
      lockPosition: 'right',
      // lockVisible: true,
      suppressHeaderMenuButton: true,
      headerClass: ['ag-grid-sidebar-toggler'],
      suppressColumnsToolPanel: true,
      cellRendererParams: {
        options: kebabMenuOptions,
        kebabMenuOptionsGenerator,
        kebabMenuIsRowSpecific,
        getUIOptionsForLastColumn,
      },
    });
  }
  return columnDefs;
};
